import {
  buildBarRankingElement,
  compileBarRankingSpec,
  validateBarRankingSpec,
} from "@/lib/ai/visualization/views/bar-ranking/logic";
import { barRankingAuthoringSchema } from "@/lib/ai/visualization/views/bar-ranking/schema";
import { defineVizView } from "@/lib/ai/visualization/views/shared/view-definition";

/**
 * `bar-ranking` definition の SSOT エントリ。
 */
export const barRankingDefinition = defineVizView({
  type: "bar-ranking",
  componentType: "BarRanking",
  authoringSchema: barRankingAuthoringSchema,
  authoringPrompt: {
    summary: "Single-metric ranked bars for top or bottom category comparison.",
    requiredKeys: ["categoryKey", "categoryLabel", "valueKey", "valueLabel"],
    optionalKeys: ["sort", "limit"],
    selectionRules: [
      'Use sort="desc" for higher-is-better metrics unless the request clearly needs a different order.',
      'Use sort="asc" for lower-is-better metrics such as rank or position.',
      "When the request explicitly asks for top N or bottom N items, set limit to that exact N.",
      "Keep exactly one primary metric visible. If multiple metrics must stay visible, choose another view.",
      "Always provide categoryLabel and valueLabel in task.outputLanguage.",
    ],
    avoidWhen: [
      "Time-based trends or current-versus-previous comparisons.",
      "Multi-metric comparisons that need grouped bars or dual axes.",
      "Leaderboard requests that must keep several supporting metrics visible at the same time.",
      "Audit/detail inspection where exact rows and many columns should stay visible.",
    ],
    minimalExamples: [
      {
        label: "single-metric-ranking",
        view: {
          type: "bar-ranking",
          categoryKey: "channel",
          categoryLabel: "Channel",
          valueKey: "sessions",
          valueLabel: "Sessions",
          sort: "desc",
          limit: 20,
        },
      },
    ],
  },
  datasetRequirements: {
    requiresTimeDimension: false,
    requiresCategoryDimension: true,
    minMetricCount: 1,
    requiresCompareMode: false,
  },
  validateSpec: validateBarRankingSpec,
  buildElement: buildBarRankingElement,
  compileSpec: compileBarRankingSpec,
});
